import { useState } from 'react';
import { Result, notification } from 'antd';
import { Button } from 'app/atoms';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { ErrorMessage, getErrorMessage } from 'utils/axios';
import { unsubscribeDocumentAlerts } from './services';
import unsubscribeImage from '../../../assets/unsubscribe-image.webp?url';
import { NotificationProps } from 'utils/types';

function DocumentUnsubscribeAlerts() {
  const { t } = useTranslation();
  const { agencyId, travelerId } = useParams();

  const [isUnsubscribed, setIsUnsubscribed] = useState(false);

  const unsubscribeMutation = useMutation({
    mutationKey: ['unsubscribeDocumentAlerts'],
    mutationFn: () => unsubscribeDocumentAlerts(agencyId, travelerId, { documentExpirationAlertsEnabled: false }),
    onSuccess: (response) => {
      notification.success({
        message: response.message,
        ...NotificationProps,
      });
      setIsUnsubscribed(true);
    },
    onError: (error: ErrorMessage) => {
      notification.error({
        message: getErrorMessage(error),
        ...NotificationProps,
      });
    },
  });

  const unsubscribe = () => {
    unsubscribeMutation.mutate();
  };

  return !isUnsubscribed ? (
    <Result
      icon={<img src={unsubscribeImage} alt="Unsubscribe" className="w-96 h-96" loading="lazy" />}
      title={t('alerts.unsubscribe.title')}
      subTitle={t('alerts.unsubscribe.subtitle')}
      extra={
        <Button type="primary" onClick={() => unsubscribe()} loading={unsubscribeMutation.isPending}>
          {t('alerts.unsubscribe.btnText')}
        </Button>
      }
      className="flex flex-col items-center justify-center h-screen"
    />
  ) : (
    <Result
      status="success"
      title={t('alerts.unsubscribed.title')}
      subTitle={t('alerts.unsubscribed.subtitle')}
      className="flex flex-col items-center justify-center h-screen"
    />
  );
}

export default DocumentUnsubscribeAlerts;
